/** Strings of the `/my` landing dashboard and its components: `myEn` is the source, `myCs` must have the same keys. */
export const myEn = {
  my: {
    title: "My Page",
    welcome: "Welcome back, {{name}}",
    defaultUserName: "User",
    thisWeek: "This week",
    thisMonth: "This month",
    details: "Details",
    entries_one: "{{count}} entry",
    entries_other: "{{count}} entries",
    entries_few: "{{count}} entries",
    noEntriesThisMonth: "No entries this month.",
    status: {
      worked: "Worked",
      budget: "Budget",
      approved: "Approved",
      rejected: "Rejected",
      rejectedOf: "of {{hours}}",
    },
    assignedToMe: "Assigned to me",
    viewAll: "View all",
    nothingAssigned: "Nothing assigned to you right now.",
    tasks_one: "{{count}} task",
    tasks_other: "{{count}} tasks",
    tasks_few: "{{count}} tasks",
    previous: "← Previous",
    next: "Next →",
    pageOf: "Page {{page}} of {{total}}",
    newItems: {
      title: "New tickets",
      show: "Show new tickets",
      none: "No new tickets assigned to you.",
    },
    strip: {
      scrollLeft: "Scroll projects left",
      scrollRight: "Scroll projects right",
      openItems_one: "{{count}} open work item assigned to you",
      openItems_few: "{{count}} open work items assigned to you",
      openItems_other: "{{count}} open work items assigned to you",
    },
  },
};
export const myCs: typeof myEn = {
  my: {
    title: "Moje stránka",
    welcome: "Vítejte zpět, {{name}}",
    defaultUserName: "uživateli",
    thisWeek: "Tento týden",
    thisMonth: "Tento měsíc",
    details: "Podrobnosti",
    entries_one: "{{count}} záznam",
    entries_other: "{{count}} záznamů",
    entries_few: "{{count}} záznamy",
    noEntriesThisMonth: "Tento měsíc zatím žádné záznamy.",
    status: {
      worked: "Odpracováno",
      budget: "Rozpočet",
      approved: "Schváleno",
      rejected: "Zamítnuto",
      rejectedOf: "z {{hours}}",
    },
    assignedToMe: "Přiřazeno mně",
    viewAll: "Zobrazit vše",
    nothingAssigned: "Právě nemáte nic přiřazeno.",
    tasks_one: "{{count}} úkol",
    tasks_other: "{{count}} úkolů",
    tasks_few: "{{count}} úkoly",
    previous: "← Předchozí",
    next: "Další →",
    pageOf: "Stránka {{page}} z {{total}}",
    newItems: {
      title: "Nové tikety",
      show: "Zobrazit nové tikety",
      none: "Nemáte přiřazené žádné nové tikety.",
    },
    strip: {
      scrollLeft: "Posunout projekty doleva",
      scrollRight: "Posunout projekty doprava",
      openItems_one: "{{count}} otevřený tiket přiřazený vám",
      openItems_few: "{{count}} otevřené tikety přiřazené vám",
      openItems_other: "{{count}} otevřených tiketů přiřazených vám",
    },
  },
};
